"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var _qy_group_dinner = require("@/api/goods_activity/qy_group_dinner");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'QyGroupDinnerTablePane',
  data: function data() {
    return {
      searchForm: {
        name: '',
        discountSubType: ''
      },
      tableData: [],
      loading: false,
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    };
  },
  mounted: function mounted() {
    this.loadData();
  },
  methods: {
    loadData: function loadData() {
      var _this = this;
      this.loading = true;
      (0, _qy_group_dinner.getQyGroupDinnerPage)(_objectSpread({
        page: this.pagination.current,
        limit: this.pagination.size
      }, this.searchForm)).then(function (response) {
        // 处理时间戳格式的时间字段
        var records = response.records || [];
        _this.tableData = records.map(function (item) {
          return _objectSpread(_objectSpread({}, item), {}, {
            startTimeStr: item.startTime ? _this.formatDateTime(item.startTime) : '',
            endTimeStr: item.endTime ? _this.formatDateTime(item.endTime) : '',
            scenes: item.scenes ? item.scenes.split(',') : []
          });
        });
        _this.pagination.total = response.total || 0;
      }).catch(function (error) {
        console.error('获取企业团餐列表失败:', error);
        _this.$message.error('获取数据失败');
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleEdit: function handleEdit(activityId) {
      this.$emit('edit', activityId);
    },
    handleDelete: function handleDelete(activityId) {
      var _this2 = this;
      this.$confirm('确定要删除这个活动吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _qy_group_dinner.deleteQyGroupDinner)(activityId).then(function () {
          _this2.$message.success('删除成功');
          _this2.loadData();
        }).catch(function (error) {
          console.error('删除企业团餐失败:', error);
          _this2.$message.error('删除失败');
        });
      }).catch(function () {
        // 取消删除
      });
    },
    handleDetail: function handleDetail(activityId) {
      // 查看详情
      this.$message.info('查看详情功能开发中');
    },
    handleToggleEnable: function handleToggleEnable(row) {
      var _this3 = this;
      (0, _qy_group_dinner.toggleEnable)(row.id, row.enabled).then(function () {
        _this3.$message.success('状态修改成功');
      }).catch(function () {
        // 失败时恢复原状态
        row.enabled = !row.enabled;
      });
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pagination.size = size;
      this.loadData();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.pagination.current = current;
      this.loadData();
    },
    getOrderStatus: function getOrderStatus(row) {
      var now = new Date().getTime();
      var startTime = row.startTime;
      var endTime = row.endTime;
      if (!startTime || !endTime) {
        return '未知';
      }
      if (now < startTime) {
        return '未开始';
      } else if (now > endTime) {
        return '已结束';
      } else {
        return '进行中';
      }
    },
    handleSwitchChange: function handleSwitchChange(id, value, type) {
      var _this4 = this;
      // 保存原始值，以便在更新失败时恢复
      var originalValue = !value;
      (0, _qy_group_dinner.updateQyGroupDinnerEnable)(id, value, type).then(function () {
        _this4.$message.success('更新成功');
      }).catch(function (error) {
        console.error('更新开关状态失败:', error);
        _this4.$message.error('更新失败');
        // 恢复原始值
        var row = _this4.tableData.find(function (item) {
          return item.id === id;
        });
        if (row) {
          if (type === 1) {
            row.balancePaySwitch = originalValue;
          } else {
            row.pointsSwitch = originalValue;
          }
        }
      });
    },
    formatDateTime: function formatDateTime(timestamp) {
      var date = new Date(timestamp);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    },
    getDiscountTypeText: function getDiscountTypeText(type) {
      var typeMap = {
        1: '满额减',
        2: '满额折',
        3: '满份减',
        4: '满份折'
      };
      return typeMap[type] || '未知';
    }
  }
};